import { Box, Grid, useTheme } from "@mui/material";
import {
	EnhancedRadioGroupRHFWithLabel,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { RHookFormMaskedTextFieldWithVerifyLabel } from "../../RHookFormMaskedTextFieldWithVerifyLabel";

interface INewAcocuntBankInfoSetupFieldsPanel {
	onVerifyBankClickedHandler: () => void;
}
export const NewAcocuntBankInfoSetupFieldsPanel: FC<
	INewAcocuntBankInfoSetupFieldsPanel
> = ({
	onVerifyBankClickedHandler
}) => {
		const theme = useTheme();
		return (
			<Box sx={{ "& .MuiTypography-root": { fontSize: ".875rem" } }}>
				<RHookFormMaskedTextFieldWithVerifyLabel
					id="accountNo"
					testId={`accountNo`}
					placeholder={"000000000000000000"}
					inputMaskPattern={"000000000000000000"}
					label={
						<>
							<Grid>Bank Account No.&nbsp;
								<span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={onVerifyBankClickedHandler}>
									[Verify]
								</span>
							</Grid>
						</>
					}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Branch/Transit No."
					id="branchTransitNumber"
					testId={`branchTransitNumber`}
					placeholder={"00000"}
					inputMaskPattern={"00000"}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Bank/Financial Institution No."
					id="bankFinancialNo"
					testId={`bankFinancialNo`}
					placeholder={"0000"}
					inputMaskPattern={"0000"}
				/>
			</Box>
		);
	};
